module.exports = __webpack_public_path__ + "img/banner-mobile.276a7b00.png";